import React, { Component, createRef } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import ChatsService from '../../controllers/ChatController';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import Toastr from '../utils/toastr';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { setPendingTransfer, closeConversationByAgent } from 'src/redux/interactionsSlice';

class Transfer extends Component {

    constructor(props) {
        super(props)
        this.state = {
            agents: [],
            userId: -1,
            groups: [],
            groupId: -1,
            loading: false
        };

        this.changeAgent = this.changeAgent.bind(this);
        this.changeGroup = this.changeGroup.bind(this);
        this.setLoading = this.setLoading.bind(this);
        this.transferError = this.transferError.bind(this);
        this.showModal = this.showModal.bind(this);

        ChatsService.registerTransferError(this.transferError);
        this.toastrRef = createRef();
    }

    changeAgent = e => {
        let userId = parseInt(e.target.value);

        this.setState({
            userId: userId,
            groupId: userId !== -1 ? -1 : this.state.groupId,
        });
    };

    changeGroup = e => {
        let groupId = parseInt(e.target.value);

        this.setState({
            groupId: groupId,
            userId: groupId !== -1 ? -1 : this.state.userId
        });
    }

    setLoading(value) {
        this.setState({
            loading: value
        });
    }

    showModal = e => {
        this.setLoading(true);

        let user = JSON.parse(localStorage.getItem("fc-logged"));
        let channel = this.props.channel;

        if (channel?.toLowerCase() === "fidelity")
            channel = "CHAT";

        ChatsService.getAvailableAgents(user.userId, agentsRes => {
            var agents = [{ userId: -1, fullName: this.props.t("none") }]

            if (agentsRes && agentsRes.data && agentsRes.data.length > 0) {
                agents = agents.concat(agentsRes.data);
            }

            ChatsService.getTransferGroups(user.userId, groupsRes => {
                var groups = [{ id: -1, name: this.props.t("none"), channel: channel }];
                if (groupsRes && groupsRes.length > 0) {
                    groups = groups.concat(groupsRes);
                    groups = groups.filter(x => x?.channel?.toLowerCase() === channel?.toLowerCase());
                }

                this.setState({
                    groups: groups,
                    agents: agents
                });
                this.setLoading(false);

            });
        });
    }

    transfer = e => {

        this.setLoading(true);

        ChatsService.transferChat(this.state.userId, this.state.groupId, this.props.conversationId, this.props.userId, x => {
            if (!x?.data) {
                this.props.closeConversationByAgent(this.props.conversationId);
            } else {
                this.props.setPendingTransfer(true);
                this.props.toggleModal();
            }
            this.setLoading(false);
        });

    }

    transferError = message => {

        this.props.setPendingTransfer(false);
        this.toastrRef.current.setType("error");
        this.toastrRef.current.setMessage(this.props.t("transfererror"));
        this.toastrRef.current.show();

    }


    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="lg">
                    <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                        <Modal.Header>
                            <Modal.Title><FontAwesomeIcon icon={duotone("arrow-right-arrow-left")} /> {this.props.t("transfer")}</Modal.Title>
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("close")}
                                </Tooltip>}>
                                <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                            </OverlayTrigger>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col>
                                    <Form>
                                        <Form.Group className="mb-4" controlId="trnAgents">
                                            <Form.Label>{this.props.t("agent")}</Form.Label>
                                            <Form.Select onChange={this.changeAgent} value={this.state.userId}>
                                                {
                                                    this.state.agents.map(elem => {
                                                        return <option key={elem.userId} value={elem.userId}>{elem.fullName}</option>
                                                    })
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group className="mb-4" controlId="trnGroups">
                                            <Form.Label>{this.props.t("group")}</Form.Label>
                                            <Form.Select onChange={this.changeGroup} value={this.state.groupId} >
                                                {
                                                    this.state.groups.map(elem => {
                                                        return <option key={elem.id} value={elem.id} >{elem.name}</option>
                                                    })
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Form>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={this.transfer}>
                                <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("send")}
                            </Button>
                        </Modal.Footer>
                    </BlockUi>
                </Modal>
                <Toastr ref={this.toastrRef} />
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userId: state.agent.userId
    };
};


export default compose(connect(mapStateToProps, { setPendingTransfer, closeConversationByAgent }), withTranslation())(Transfer);